import type { NavSection } from '@/lib/types';

const NAV_SECTION_LABELS: Record<NavSection, string> = {
  setup: 'Setup',
  quality: 'Quality',
};

export function navSectionLabel(section?: NavSection | string): string | undefined {
  if (!section) return undefined;
  if (section in NAV_SECTION_LABELS) {
    return NAV_SECTION_LABELS[section as NavSection];
  }
  return section;
}

/** Shared header dropdown group order (matches permission catalog bands). */
export const ADMIN_HEADER_NAV_GROUPS: Array<{ id: string; label: string }> = [
  { id: 'operations', label: 'Operations' },
  { id: 'platform', label: 'Platform' },
  { id: 'monitoring', label: 'Monitoring' },
  { id: 'admin', label: 'Admin' },
  { id: 'development', label: 'Tools' },
];
